import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class EntityManagerService {
  constructor(private api: ApiService) {}

  // GET API

  getCollectionField(payload, isShortDetails: boolean = false) {
    return this.api.post(`/collections/fields-by-module${isShortDetails ? '-short' : ''}`, payload);
  }

  getEntityList() {
    return this.api.get('/eng/getall?office_id=' + this.api.getOfficeId());
  }

  getCustomField(id) {
    return this.api.get('/eng/custom-fields/getall/' + id);
  }

  resetEntityList() {
    return this.api.get('/eng/resetAll/' + this.api.getOfficeId());
  }

  // POST API

  createEntity(payload) {
    return this.api.post('/eng/create', payload);
  }

  // PUT API

  updateEntity(id, payload) {
    return this.api.put('/eng/update/' + id, payload);
  }

  updateCustomFields(id, payload) {
    return this.api.put('/eng/custom-fields/' + id, payload);
  }

  // DELETE API

  deleteEntity(id) {
    return this.api.delete('/eng/delete/' + id);
  }
}
